<template>
    <div class="index" v-if="page_show">
        <div class="flex__around search-box">
            <div class="flex align-center search__item" v-link='"/Mall/Search"'>
                <span class="fs_28 c_b3 jcicon jcicon-sousuo1"></span>
                <span class="fs_28 c_b3">&nbsp;请输入关键字搜索</span>
            </div>
        </div>
        <div class="swiper-box" v-if="renders.carousel">
            <swiper :options="swiperOption">
                <swiper-slide v-for="(item,index) in renders.carousel" :key="index"><img :src="item.image" @click="link(item.link_url)"></swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <div class="category-box" v-if="renders.category">
            <swiper :options="swiperOptions">
                <swiper-slide class="flex wrap" v-for="(item,index) in renders.category" :key="index">
                    <div class="flex__between align-center column category__item" v-for="(item1,index1) in item" :key="index1" v-link="'/mall/List/'+item1.id+'/0'">
                        <img :src="item1.cover_img" alt="">
                        <span class="fs_14 c_4d">{{item1.name}}</span>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!-- 广告 -->
        <div class="advert-box">
            <div class="ad_position_one" @click="link(renders.ad_position_one[0].link_url)" v-if="renders.ad_position_one[0].image">
                <img :src="renders.ad_position_one[0].image" alt="" v-img="{w:345,h:110}">
            </div>
            <!-- 多个广告图 -->
            <div v-if="renders.ad_position_two.length==1">
                <div @click="link(renders.ad_position_two[0].link_url)" class="img-box--one img-big">
                    <img :src="renders.ad_position_two[0].image" alt="" v-img="{w:345,h:110}">
                </div>
            </div>
            <div v-else-if="renders.ad_position_two.length==2">
                <div class="flex__between img-box--two">
                    <div class="img-middle" @click="link(renders.ad_position_two[0].link_url)">
                        <img :src="renders.ad_position_two[0].image" alt="" v-img="{w:170,h:185}">
                    </div>
                    <div class="img-middle" @click="link(renders.ad_position_two[1].link_url)">
                        <img :src="renders.ad_position_two[1].image" alt="" v-img="{w:170,h:185}">
                    </div>
                </div>
            </div>
            <div v-else-if="renders.ad_position_two.length==3">
                <div class="flex__between img-box--three">
                    <div class="img-middle" @click="link(renders.ad_position_two[0].link_url)">
                        <img :src="renders.ad_position_two[0].image" alt="" v-img="{w:170,h:185}">
                    </div>
                    <div class="flex__null__between img-small">
                        <div @click="link(renders.ad_position_two[1].link_url)">
                            <img :src="renders.ad_position_two[1].image" alt="" v-img="{w:170,h:160}">
                        </div>
                        <div @click="link(renders.ad_position_two[2].link_url)">
                            <img :src="renders.ad_position_two[2].image" alt="" v-img="{w:170,h:160}">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 商品列表 -->
        <div class="sale-box">
            <div class="sale__title">
                <span class="fs_40 c_1a fw_500">精选商品</span>
                <span class="fs_24 c_b3">精选好物带回家</span>
            </div>
            <div class="flex__between wrap">
                <div class="sale__item" v-for="(item,index) in list" :key="index" v-link="'/Mall/Detail/'+item.id">
                    <img :src="item.cover_img" alt="">
                    <div class="flex__null__between sale__info">
                        <div class="fs_28 c_1a lh_40 ellipsis_two">{{item.name}}</div>
                        <div class="mt_10 lh_40">
                            <span class="fs_26 c_main">¥</span>
                            <span class="fs_30 c_main">{{item.price}}</span>
                            <span class="fs_24 c_80">&ensp;已售{{item.sales}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <jc-list :url="'/Mall/getIndexList'" :loads="loads" @load='getList'></jc-list>
        </div>
        <tab-bar :current='0'></tab-bar> 
    </div>
</template>
<script>
import Swiper from 'swiper'
export default {
    name:'Index',
    data(){
        return {
            page_show:false,// 页面展示优化
            renders:{
                ad_position_one:[{}],
                ad_position_two:[{}]
            },
            list:[],
            loads:{page:1},
            swiperOption: {
                initialSlide :1,
                loop : true,
                autoplay: 3000,
                autoplayDisableOnInteraction:false,
                pagination: '.swiper-pagination',
                indicatorColor: '#000'
            },
            swiperOptions: {
                autoplay: false,
                pagination: '.swiper-pagination'
            }
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        // 跳转外链
        link(url){
            if(url){
                window.location.href=url;
            }
        }
    },
    mounted(){
        this.httpPost({
            url:'/Mall/getIndexData',
            params:{},
            loading:1
        }).then(
            res=>{
                if(res.code==1){
                    this.page_show=true;
                    this.renders=res.data;
                }
            }
        )
    }
}
</script>

<style scoped>
.swiper-box{
    padding: 10px 30px;
    background: #fff;
}
.swiper-box img{
    width:690px;
    height:300px;
    border-radius: 10px;
}
.category-box{
    background: #fff;
}
.category-box .swiper-container{
    padding-bottom: 70px;
}
.category-box img{
    width: 90px;
    height: 90px;
    border-radius: 50%;
}
.category__item{
    width: 150px;
    height: 130px;
    margin-top: 30px;
}
.category__item:nth-child(5n+1){
    margin-left: 0;
} 
/* 广告 */
.advert-box{
    margin-top: 15px;
    padding: 15px 30px;
    background: #fff;
} 
.ad_position_one{
    position: relative;
    height: 220px;
}
/* 多类型广告 */
.img-box--one,.img-box--two,.img-box--three{
    margin-top: 15px;
}
.img-big{
    position: relative;
    width: 690px;
    height: 220px;
}
.img-middle{
    position: relative;
    width: 340px;
    height: 370px;
}
.img-small{
    position: relative;
    width: 340px;
    height: 180px;
}
/* 商品 */
.sale-box{
    padding: 0 24px;
}
.sale__title{
    padding: 40px 0 0;
}
.sale__item{
    width: 340px;
    margin-top: 20px;
    background: #fff;
    border-radius: 10px;
}
.sale__item img{
    width: 340px;
    height: 340px;
    border-radius: 10px 10px 0 0;
}
.sale__info{
    height: 165px;
    padding: 20px 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/mall/Index.vue